// @ts-strict-ignore
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import { type IFetchReportPayload, type IReportRequest, ReportRequestName } from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchNewTickets(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.NewTickets,
      interface: ApiManager.reportApi.fetchNewTickets,
    },
    {
      name: ReportRequestName.TicketSources,
      interface: ApiManager.reportApi.fetchTicketSources,
    },
  ];

  yield makeFetchingSaga(ReportType.NewTickets, action, requests);
}
